import { Component, OnInit } from '@angular/core';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';

@Component({
	selector: 'app-recovery',
	templateUrl: './recovery.component.html',
	styleUrls: ['./recovery.component.scss']
})
export class RecoveryComponent {
	recoveryEmail = '';
	sendButtonClicked = false;
	successfullySent = false;
	unsuccessfullySent = false;

	constructor(private facade: FacadeService, private logger: LogService) {}

	// ngOnInit() {}

	sendPasswordRecovery(): void {
		this.sendButtonClicked = true;
		const email = this.recoveryEmail;
		this.recoveryEmail = '';

		this.facade.userService.retrievePassword(email).subscribe({
			next: (succ) => {
				this.sendButtonClicked = false;
				this.successfullySent = true;
			},
			error: (err) => {
				this.facade.toastService.createHttpErrorToast(
					err.error.response ? err.error.response : '',
					err.status
				);
				this.logger.log(
					'' + err.status + ' ' + err.error.response ? err.error.response : ''
				);
				this.sendButtonClicked = false;
				this.unsuccessfullySent = true;
			}
		});
	}

	closeAlerts(): void {
		this.sendButtonClicked = false;
		this.successfullySent = false;
		this.unsuccessfullySent = false;
	}
}
